import React from 'react';

import getUserPhotoUrl from '../../../helpers/getUserPhotoUrl';
import usericon from '../../../assets/images/usericon.webp';
import classes from './styles.module.scss';

export default function Answer({ answer }) {
  return (
    <div className={classes.Answer}>
      <div className={classes.header}>
        <div className={classes.userpic}>
          <img
            alt="User"
            src={getUserPhotoUrl(answer.User?.photoPath) || usericon}
          />
        </div>
        <div>
          <h1>{answer.User?.name}</h1>
          <h2>{answer.User?.title}</h2>
        </div>
      </div>
      <div className={classes.text}>
        <p>{answer.text}</p>
      </div>
    </div>
  );
}
